import { twMerge } from 'tailwind-merge';

interface TabItemProps {
  text: string;
  active?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  disabled?: boolean;
  onChange?: () => void;
  className?: string;
}

export const TabItem = ({
  text,
  active,
  leftIcon,
  rightIcon,
  disabled,
  onChange,
  className,
}: TabItemProps) => {
  const handleClick = () => {
    if (disabled) {
      return;
    }

    // Remove hash from URL
    if (window.location.hash) {
      history.pushState(
        '',
        document.title,
        window.location.pathname + window.location.search
      );
    }

    // Call the onChange handler if provided
    onChange?.();
  };

  return (
    <div
      className={twMerge(
        'btn btn-clear',
        active && 'active btn-primary',
        disabled && 'opacity-50',
        className
      )}
      onClick={handleClick}
    >
      {leftIcon && <>{leftIcon}</>}
      <span className="mt-0.5">{text}</span>
      {rightIcon && <>{rightIcon}</>}
    </div>
  );
};
